// 직원 인증(계약 §2). 로그인·가입·재설정은 토큰 없이 부른다 — http 가 토큰이 없으면 머리말을 안 붙인다.
import { http, data } from "../inquiry/v6Api";

export const login = (email, password) => data(http.post("/admin/auth/login", { email, password }));
export const me = () => data(http.get("/admin/auth/me"));
// 첫 로그인(must_change_password)에는 current_password 를 보내지 않아도 된다
export const changePassword = (newPw, currentPw) =>
    data(http.post("/admin/auth/password", { new_password: newPw, ...(currentPw !== undefined ? { current_password: currentPw } : {}) }));
export const signupOptions = () => data(http.get("/admin/auth/signup-options"));
export const signup = (body) => data(http.post("/admin/auth/signup", body));
export const requestReset = (email) => data(http.post("/admin/auth/password-reset/request", { email }));
export const confirmReset = (token, newPw) => data(http.post("/admin/auth/password-reset/confirm", { token, new_password: newPw }));
